// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendOtp-module__otpLoginContainer___Xq1Aj {
  width: 360px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
}

.SendOtp-module__otpHeader___iUzBG {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.SendOtp-module__otpHeader___iUzBG h2 {
  font-size: 20px;
  margin: 0;
  color: #111;
}

.SendOtp-module__closeBtn___m4WPE {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #333;
}

.SendOtp-module__otpSubText___Wss8c {
  font-size: 14px;
  color: #666;
  margin: 12px 0 16px;
}

.SendOtp-module__phoneInput___CBQC5 {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}

.SendOtp-module__phoneInput___CBQC5:focus {
  border-color: #007bff;
}

.SendOtp-module__sendOtpBtn___GSHvU {
  width: 100%;
  background: #007bff;
  color: white;
  padding: 12px;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin: 16px 0;
  transition: background 0.3s ease;
}

.SendOtp-module__sendOtpBtn___GSHvU:hover {
  background: #0056cc;
}

.SendOtp-module__loginWithPassword___VjIt_ {
  text-align: center;
  font-size: 13px;
  color: #444;
  cursor: pointer;
}

.SendOtp-module__loginWithPassword___VjIt_:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/modals/sendotp/SendOtp.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".otpLoginContainer {\n  width: 360px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.otpHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.otpHeader h2 {\n  font-size: 20px;\n  margin: 0;\n  color: #111;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  color: #333;\n}\n\n.otpSubText {\n  font-size: 14px;\n  color: #666;\n  margin: 12px 0 16px;\n}\n\n.phoneInput {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n}\n\n.phoneInput:focus {\n  border-color: #007bff;\n}\n\n.sendOtpBtn {\n  width: 100%;\n  background: #007bff;\n  color: white;\n  padding: 12px;\n  font-size: 14px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  margin: 16px 0;\n  transition: background 0.3s ease;\n}\n\n.sendOtpBtn:hover {\n  background: #0056cc;\n}\n\n.loginWithPassword {\n  text-align: center;\n  font-size: 13px;\n  color: #444;\n  cursor: pointer;\n}\n\n.loginWithPassword:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otpLoginContainer": `SendOtp-module__otpLoginContainer___Xq1Aj`,
	"otpHeader": `SendOtp-module__otpHeader___iUzBG`,
	"closeBtn": `SendOtp-module__closeBtn___m4WPE`,
	"otpSubText": `SendOtp-module__otpSubText___Wss8c`,
	"phoneInput": `SendOtp-module__phoneInput___CBQC5`,
	"sendOtpBtn": `SendOtp-module__sendOtpBtn___GSHvU`,
	"loginWithPassword": `SendOtp-module__loginWithPassword___VjIt_`
};
export default ___CSS_LOADER_EXPORT___;
